import fetch from 'cross-fetch';
import { ApiV1Base, ApiPrefix, statusCheck, json, getCookie } from '../util/icwUtility';
import { actLoginTimedOut } from './loginStateActions';

export const PRODUCT_CATEGORY_LIST_FETCH_BEGIN = 'PRODUCT_CATEGORY_LIST_FETCH_BEGIN';
function actProductCategoryListFetchBegin() {
  return { type: PRODUCT_CATEGORY_LIST_FETCH_BEGIN };
}

export const PRODUCT_CATEGORY_LIST_FETCH_SUCCESS = 'PRODUCT_CATEGORY_LIST_FETCH_SUCCESS';
export function actProductCategoryListFetchSuccess(data) {
  return { type: PRODUCT_CATEGORY_LIST_FETCH_SUCCESS, data };
}

export const PRODUCT_CATEGORY_LIST_FETCH_FAIL = 'PRODUCT_CATEGORY_LIST_FETCH_FAIL';
function actProductCategoryListFetchFail(reason) {
  return { type: PRODUCT_CATEGORY_LIST_FETCH_FAIL, reason };
}

export function actProductCategoryListFetch() {
  return (dispatch) => {
    dispatch(actProductCategoryListFetchBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/productCategories`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => dispatch(actProductCategoryListFetchSuccess(data)))
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductCategoryListFetchFail(typeof err === 'object' ? err.message : err));
      });
  };
}
